import type { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/mergeMap';
import { RETRY, changeSearch, loadMore, fetchInitialBoards } from '../../state/actions.tsx';
import {
	isSearchUsed as isSearchUsedSelector,
	getSearchValue,
	shouldRetryLoadMore as shouldRetryLoadMoreSelector,
} from '../../state/selectors.tsx';
import type { State } from '../../state/types.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const retryEpic: Epic<any, State> = (action$, store) =>
	// @ts-expect-error - TS2322 - Type 'Observable<LoadMoreAction>' is not assignable to type 'Observable<State>'. | TS2345 - Argument of type '() => Observable<LoadMoreAction> | Observable<SearchChangedAction>' is not assignable to parameter of type '(value: State, index: number) => ObservableInput<LoadMoreAction>'.
	action$.ofType(RETRY).mergeMap(() => {
		const state = store.getState();

		const isSearchUsed = isSearchUsedSelector(state);
		const searchValue = getSearchValue(state);
		const shouldRetryLoadMore = shouldRetryLoadMoreSelector(state);

		if (shouldRetryLoadMore) {
			return Observable.of(loadMore());
		}
		if (isSearchUsed) {
			return Observable.of(changeSearch(searchValue));
		}

		// @ts-expect-error - TS2769 - No overload matches this call.
		return Observable.of(changeSearch(''), fetchInitialBoards());
	});
